import { OptionFilter } from '../filters';
import { PERISCOPE_FILTER_PLACEHOLDER } from '@sonar-software/sonar-ts-constants';
import React, { useMemo } from 'react';
import { UpdateQueryParams, useApiResource } from '@hooks';

export interface ModifiedByFilterQueryParams {
	userNames?: Array<string>;
}

export interface ModifiedByFilterProps {
	onChange: UpdateQueryParams<ModifiedByFilterQueryParams>;
	sonarObjectId: number;
}

export const ModifiedByFilter: React.FC<ModifiedByFilterProps> = ({ onChange, sonarObjectId }) => {
	const { loading, resource } = useApiResource<{ userNames: Array<string> }>(
		`v3/core/sonar-objects/${sonarObjectId}/timelines/users`
	);

	const userOptions = useMemo(() => (resource?.userNames ?? []).map((user) => ({
		label: user,
		value: user
	})), [ resource?.userNames ]);

	return <OptionFilter
		loading={ loading }
		onChange={ (value) => onChange({ userNames: [ value as string ] }) }
		options={ userOptions }
		placeholder={ PERISCOPE_FILTER_PLACEHOLDER.FILTER_BY_MODIFIED_BY } />;
};
